// eslint-disable-next-line import/no-anonymous-default-export
export default (location = [], action) => {
  switch (action.type) {
    case "FETCH_ALL_LOCATION":
      return action.payload;

    case "CREATE_LOCATION":
      return [...location, action.payload];
    case "DELETE_LOCATION":
      return location.filter((lo) => lo._id !== action.payload);

    default:
      return location;
  }
};
